import React, { useContext, useState } from 'react'
import { Modal, NotificationManagerContext, Spacer, Text, View } from 'oio-react'
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom'
import { settingsSiteUrl } from 'config/constants/urls'
import IntegrationGoogleAnalytics from 'src/components/Settings/IntegrationGoogleAnalytics'
import IntegrationListItemRow from 'src/components/Settings/IntegrationListItemRow'
import IntegrationStripeListItemRow from 'src/components/Settings/IntegrationStripeListItemRow'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'
import { useOrganization, useUpdateOrganization } from 'src/graphql/hooks'

const SettingsSiteIntegrations = () => {
   const { organization } = useOrganization()
   const { updateOrganization, mutating: updating } = useUpdateOrganization()
   const { showNotification } = useContext(NotificationManagerContext)

   // TODO: This is a temporary solution to ensure that modals can animate out
   // when the action to close the modal is triggered. A more permanent solution
   // would be to used a state machine that wraps or replaces the Switch below
   // (similar to how TransitionGroup works).
   const [modalIsOpen, setModalIsOpen] = useState(true)
   const history = useHistory()
   const match = useRouteMatch()

   const handleGoogleAnalyticsDisconnect = async () => {
      try {
         await updateOrganization({ tmpGoogleAnalyticsTrackingId: null })
         showNotification({
            message: 'Integration successfully disconnected',
            title: 'Success!',
            type: 'success'
         })
      } catch (error) {
         showNotification({
            message: error.graphQLErrors.map(e => e.message).join(', ') || error.message,
            title: 'Error!',
            type: 'error'
         })
      }
   }

   return (
      <View>
         <ProtoReturnBar
            display="block[a-d] none[e-f]"
            returnLinkName="Site Settings"
            returnLinkTo={settingsSiteUrl}
         />
         <View
            display="flex"
            justifyContent="center">
            <View
               maxWidth="100%[a-c] 600px[d-f]"
               padding="40px 20px">
               <View
                  width="100%"
                  display="flex"
                  flexFlow="column[a-c] row[d-f]">
                  <View paddingRight="30px[b-c] 240px[d-f]">
                     <ProtoHeadingBlock
                        title="Integrations"
                        description="Connect the following great third-party tools for your Community Site"
                     />
                  </View>
               </View>
               <View
                  width="100%"
                  padding="15px 0px">
                  <Spacer size="3" />
                  <Text size="0.9" weight="bold" color="#000" transform="uppercase">
                     Active Integrations
                  </Text>
               </View>
               <View
                  width="100%"
                  borderRadius="6px"
                  backgroundColor="#fff">
                  {organization.tmpGoogleAnalyticsTrackingId && (
                     <IntegrationListItemRow
                        buttonMode={updating ? 'loading' : 'normal'}
                        connected
                        borderTopStyle="none"
                        onClick={handleGoogleAnalyticsDisconnect}
                        iconUrl="/assets/images/integrations/google-analytics.svg"
                        name="Google Analytics"
                        description="Google Analytics is a free web analytics service that allows you to analyze in-depth detail about the visitors on your website."
                     />
                  )}
                  {organization.commerceEnabled && (
                     <IntegrationStripeListItemRow />
                  )}
               </View>
               <View
                  width="100%"
                  padding="15px 0px">
                  <Spacer size="3" />
                  <Text size="0.9" weight="bold" color="#000" transform="uppercase">
                     Available Integrations
                  </Text>
               </View>
               <View
                  width="100%"
                  borderRadius="6px"
                  backgroundColor="#fff">
                  {!organization.tmpGoogleAnalyticsTrackingId && (
                     <IntegrationListItemRow
                        borderTopStyle="none"
                        linkTo={`${match.url}/google-analytics`}
                        iconUrl="/assets/images/integrations/google-analytics.svg"
                        name="Google Analytics"
                        description="Google Analytics is a free web analytics service that allows you to analyze in-depth detail about the visitors on your website."
                     />
                  )}
                  {!organization.commerceEnabled && (
                     <IntegrationStripeListItemRow />
                  )}
               </View>
            </View>
         </View>
         <Switch>
            <Route
               path={`${match.url}/google-analytics`}
               render={() => (
                  <Modal
                     borderRadius="6px"
                     width="100%[a-b] 720px[c-f]"
                     height="100%[a-b] 480px[c-f]"
                     onCloseComplete={() => {
                        history.push(match.url)
                        setModalIsOpen(true)
                     }}
                     onCloseTrigger={() => setModalIsOpen(false)}
                     open={modalIsOpen}>
                     <IntegrationGoogleAnalytics
                        onCloseButtonClick={() => setModalIsOpen(false)}
                     />
                  </Modal>
               )}
            />
         </Switch>
      </View>
   )
}

export default SettingsSiteIntegrations
